import api from '../api/directors'
import apiClients from '../api/clients'

export const actionTypes = {
	RECEIVE_DIRECTORS: 'enterprise/RECEIVE_DIRECTORS',
  RECEIVE_CLIENTS: 'enterprise/RECEIVE_CLIENTS'
}

export const loadDirectors = (id) => {
  return(dispatch, getStore) => {
    api.fetchDirectorsList(id)
      .then((data) => dispatch(receiveDirectors(data)))
  }
}

function receiveDirectors(APIdata) {
  return {
    type: actionTypes.RECEIVE_DIRECTORS,
    data: APIdata.data
  }
}

export const loadClients = () => {
  return(dispatch, getStore) => {
    apiClients.fetchClients()
      .then((data) => dispatch(receiveClients(data)))
  }
}

function receiveClients(APIdata) {
  return {
    type: actionTypes.RECEIVE_CLIENTS,
    data: APIdata
  }
}


// WEBPACK FOOTER //
// ./src/actions/enterprise.js